<template>
  <div>
    <div v-if="isLoading">
      <b-spinner small></b-spinner> {{ $t("loading...") }}
    </div>
    <div v-show="!isLoading">
      <b-row>
        <b-col md="3" v-for="f in filters" v-bind:key="f.name">
          <b-form-group :label="f.caption">
            <b-select v-model="f.value" v-on:change="loadData">
              <b-select-option :value="null">--</b-select-option>
              <b-select-option v-for="d in f.data" v-bind:key="d" :value="d">
                {{ d }}
              </b-select-option>
            </b-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group :label="$t('sort')">
            <b-dropdown variant="outline-primary">
              <template #button-content>
                <span v-if="sortType === 0"> {{ $t('select_sort_type') }} </span>
                <span v-else-if="sortType === 1">
                  <i class="fas fa-sort-alpha-up-alt" /> {{ $t('sort_name_asc') }}
                </span>
                <span v-else-if="sortType === 2">
                  <i class="fas fa-sort-alpha-down" /> {{ $t('sort_name_desc') }}
                </span>
                <span v-else-if="sortType === 3">
                  <i class="fas fa-sort-amount-up-alt" /> {{ $t('sort_value_asc') }}
                </span>
                <span v-else-if="sortType === 4">
                  <i class="fas fa-sort-amount-down" /> {{ $t('sort_value_desc') }}
                </span>
              </template>
              <b-dropdown-item @click="sortType = 1"><i class="fas fa-sort-alpha-up-alt" />
                {{ $t('sort_name_asc') }}
              </b-dropdown-item>
              <b-dropdown-item @click="sortType = 2"><i class="fas fa-sort-alpha-down" />
                {{ $t('sort_name_desc') }}</b-dropdown-item>
              <b-dropdown-item @click="sortType = 3"><i class="fas fa-sort-amount-up-alt" />
                {{ $t('sort_value_asc') }}
              </b-dropdown-item>
              <b-dropdown-item @click="sortType = 4"><i class="fas fa-sort-amount-down" />
                {{ $t('sort_value_desc') }}
              </b-dropdown-item>
            </b-dropdown>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <highcharts :constructor-type="'mapChart'" :options="chartOptions" :highcharts="hcInstance" />
        </b-col>
        <b-col md="6">
          <highcharts :options="chartOptions2" :highcharts="hcInstance2" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Highcharts from "highcharts";

import Api from "@/api";

export default {
  props: ["viewId", "viewConfig"],
  data: () => ({
    isLoading: true,
    hcInstance: Highcharts,
    hcInstance2: Highcharts,
    data: [],
    filters: [],
    mapData: [],
    azMapCodes: [],
    chartOptions: {},
    chartOptions2: {},
    sortType: 0
  }),
  created() {
    this.azMapCodes = require("@/data/az_map_codes.json");
    this.azMapAz = require("@/data/az_map.az.json");
    this.azMapEn = require("@/data/az_map.en.json");

    this.loadFilters();
    this.loadData();
  },
  methods: {
    loadData() {
      let filterString = "";

      this.filters.forEach((filter) => {
        if (filter.value)
          filterString += `${filter.name}=${filter.value}&`;
      });

      filterString = filterString.slice(0, -1);

      Api.getMapData(this.viewId, filterString).then((response) => {
        this.data = [];
        this.mapData = [];

        response.forEach((el) => {
          this.mapData.push([el.regionCode, el.value]);
          this.data.push([el.regionName, el.value]);
        });

        this.fillMapData();
        this.fillHighChart();
      }).finally(() => this.isLoading = false);
    },

    loadFilters() {
      if (this.viewConfig.filters !== undefined) {
        this.viewConfig.filters.forEach((filter) => {
          Api.getData(filter.dataUrl)
            .then((response) => this.filters.push({ name: filter.name, caption: filter.caption, data: response, value: null }))
            .catch();
        });
      }
    },

    fillMapData() {
      this.chartOptions = {
        chart: {
          map: this.$i18n.locale === "az" ? this.azMapAz : this.azMapEn,
          height: 550,
        },
        title: {
          text: " ",
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            alignTo: "spacingBox",
          },
        },
        colorAxis: {
          min: 0,
          stops: [
            [0, '#FFFFFF'],
            [1, this.viewConfig.mapColor ?? '#1e6005']
          ]
        },
        series: [
          {
            name: "Miqdar",
            color: "#5472CC",
            states: {
              hover: {
                color: "#1e6005",
              },
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}",
            },
            allAreas: false,
            data: this.mapData,
          },
        ],
      };
    },

    fillHighChart() {
      var sortedData = this.data;

      if (this.sortType == 0) {
        sortedData = this.data;
      } else if (this.sortType == 1) {
        sortedData = this.data.sort(function (a, b) {
          return b[0] < a[0] ? 1 : -1;
        });
      } else if (this.sortType == 2) {
        sortedData = this.data.sort(function (a, b) {
          return b[0] > a[0] ? 1 : -1;
        });
      } else if (this.sortType == 3) {
        sortedData = this.data.sort(function (a, b) {
          return a[1] - b[1];
        });
      } else if (this.sortType == 4) {
        sortedData = this.data.sort(function (a, b) {
          return b[1] - a[1];
        });
      }

      this.chartOptions2 = {
        chart: {
          type: "column",
          inverted: true,
          height: 550,
          width: 650,
        },
        title: {
          text: " ",
        },
        xAxis: {
          type: "category",
          labels: {
            style: {
              fontSize: "8px",
              fontFamily: "Verdana, sans-serif",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: " ",
          }
        },
        legend: {
          enabled: false,
        },
        series: [
          {
            data: sortedData,
            color: this.viewConfig.mapColor ?? '#1e6005',
            states: {
              hover: {
                color: "#1e6005",
              },
            },
            name: "Miqdar",
            allAreas: false,
          },
        ],
      };
    },
  },
  watch: {
    "viewConfig.filters": {
      handler(value) {
        this.loadFilters();
      }
    },

    "sortType": {
      handler(value) {
        this.fillHighChart();
      }
    }
  }
}
</script>